/**
 * Media Component
 * 
 * @module components/media
 */

import Component from './component';
import { getModule } from '../utils/modules';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  /**
   * Media component class
   */
  class Media extends Component {
    constructor(element, options = {}) {
      super(element, options);
      this.name = 'media';
    }

    /**
     * Main initializer
     * 
     * @returns void
     */
    init() {
      const el = this.element;

      if (el.hasClass(this.initializedClass)) {
        // only need to initialize this component once
        return;
      }

      // if plyr is not loaded yet, load it now and postpone the init until it's loaded
      if (!Media.Plyr) {
        getModule('plyr')
          .then(Plyr => {
            Media.Plyr = Plyr;
            this.init();
          })
          .catch(err => {
            this.logError(err);
          });

        return;
      }

      // mark as initialized
      el.addClass(this.initializedClass);

      this.initPlayer();
    }

    /**
     * Initialize player
     */
    initPlayer() {
      this.elPlayer = this.element.find(Media.selectors.playerDiv);
      // no player div found
      if (!this.elPlayer.length) {
        return;
      }

      // get the provider and ensure it's one of the supported providers
      const provider = (this.elPlayer.attr('data-plyr-provider') || '').toLowerCase();
      if (provider && Media.supportedProvider.indexOf(provider) >= 0 && typeof Media.providerSetup[provider] === 'function') {
        const embedId = this.elPlayer.attr('data-plyr-embed-id');
        if (embedId) {
          this.provider = provider;
          this.embedId = embedId;
          Media.providerSetup[provider](this);
        }
      }
    }
  }

  // selector constant
  Media.selectors = {
    playerDiv: '[data-plyr-provider]'
  };

  // supported provider
  Media.supportedProvider = ['youtube'];

  // setup player
  Media.providerSetup = {
    'youtube': (instMedia) => {
      instMedia.player = new Media.Plyr(instMedia.elPlayer[0], {
        ratio: '16:9',
        noCookie: false, 
        rel: 0, 
        showinfo: 0, 
        iv_load_policy: 3, 
        modestbranding: 1,
        autoplay: 0,
        hl: document.documentElement.lang || 'fr'
      });
    }
  };

  return Media;
})(jQuery, window);